let menu_acordion = document.querySelectorAll('.extra-collection-menu svg');

if(menu_acordion.length){
    menu_acordion.forEach((item,key)=>{
        item.addEventListener('click', (e)=>{

            // e.target.nextElementSibling.classList.toggle('active');

            e.target.closest(".menu-link").classList.toggle('active')
        })
    })
};

function addClassToParent(el){
    let parentCustom = el.closest('ul');

    if(parentCustom.classList.contains('extra-collection-menu')){
        return true;
    }else {
        parentCustom.closest('li').classList.add('active');
        return addClassToParent(parentCustom.closest('li'));
    }
}

let active_item_menu = document.querySelector('.extra-collection-menu .bold');
addClassToParent(active_item_menu);





